var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';
import { analytics } from 'app/utils/segment';
import styles from './titleInput.module.scss';
export class TitleInput extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleInput = (event) => {
            if (event.target instanceof HTMLInputElement) {
                this.setState({
                    value: event.target.value,
                });
            }
        };
        this.handleOnChange = () => {
            const { onChange, initialValue } = this.props;
            const { value } = this.state;
            if (value !== initialValue)
                onChange(value);
            this.setState({
                isEditing: false,
            });
        };
        this.handleFocus = () => {
            const { flowType } = this.props;
            analytics.flowTitleEditClicked({
                flowType,
            });
            this.setState({
                isEditing: true,
            });
        };
        this.handleBlur = () => {
            this.setState({
                isEditing: false,
            }, this.handleOnChange);
        };
        this.handleKeyUp = (event) => {
            if (event.key === 'Enter') {
                this.handleOnChange();
                this.setState({
                    isEditing: false,
                });
            }
            else if (event.key === 'Escape') {
                const { initialValue } = this.props;
                this.setState({
                    isEditing: false,
                    value: initialValue,
                });
            }
        };
        const { initialValue } = props;
        this.state = {
            value: initialValue,
            isEditing: false,
        };
    }
    render() {
        const _a = this.props, { className, initialValue, onChange, flowType } = _a, otherProps = __rest(_a, ["className", "initialValue", "onChange", "flowType"]);
        const { value, isEditing } = this.state;
        const rootClass = classnames({
            [styles.root]: true,
            [styles.rootEditing]: isEditing,
            [styles.rootUntitled]: value === '',
        }, className);
        return (_jsx("div", Object.assign({}, otherProps, { className: rootClass }, { children: _jsxs("label", Object.assign({ className: styles.preview }, { children: [_jsx("span", Object.assign({ className: styles.text }, { children: value || 'Name your flow' })), _jsx("div", Object.assign({ className: styles.inputContainer }, { children: _jsx("input", { spellCheck: "false", onFocus: this.handleFocus, onBlur: this.handleBlur, className: styles.input, onChange: this.handleInput, onKeyUp: this.handleKeyUp, value: value, placeholder: "Name your flow" }) })), _jsx(Icon, { className: classnames('icon-vertical-fix', styles.icon), name: "pen" })] })) })));
    }
}
